
const CouponUserGiftIndex= () =>import('@/components/couponusergift/Index')
export default[
    {
        path: '/coupon/coupon_user_gift',
        component: CouponUserGiftIndex,
        meta: {title: '送优惠券'}
    }

]




// WEBPACK FOOTER //
// ./src/router/couponRouter.js